module.exports = __webpack_public_path__ + "static/img/ent-detail-88.85e30bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-88.jpg
// module id = 5NAT
// module chunks = 51